import { TChatbotAgent } from '~/features/agents/models'
import { getAgentChatSettings } from '~/features/agents/utils'
import { EMessageSpeaker } from '~/models/features'

const getAgentAndChatbotDetails = (agent: TChatbotAgent) => {
  const chatSettings = getAgentChatSettings(agent.chatSettings)
  const layout = chatSettings?.layout

  const agentDetails = {
    id: agent.id,
    businessName: agent.businessName,
    agentName: agent.agentName,
    chatIntro: agent.chatIntro,
    chatbotImgURL: agent.chatbotImgURL,
    service: agent.service,
    customLinks: agent.customLinks,
    showLibby: agent.showLibby,
    showBranding: agent.showBranding,
    calendlyLink: agent.calendlyLink,
    chatStatus: agent.chatStatus,
    chatSettings: chatSettings
      ? {
          ...chatSettings,
          form: chatSettings?.form || null,
        }
      : undefined,
  }

  return {
    agent: agentDetails,
    messages: [
      {
        message: agent.chatIntro ?? '',
        speaker: EMessageSpeaker.assistant,
      },
    ],
    // Already present on this same guest-agent response (agentDetails.chatSettings
    // above) — this used to come from a second, separate useGetChatbotSettings
    // call hitting the legacy Amplify Lambda, purely to populate this one
    // top-level store field. No reason to fetch it twice.
    ...(layout && { layout }),
  }
}

/** Guest-agent refetch: agent + layout only — never overwrites in-session messages. */
export const getChatbotSettingsUpdateFromAgent = (agent: TChatbotAgent) => {
  const { agent: agentDetails, layout } = getAgentAndChatbotDetails(agent)

  return {
    agent: agentDetails,
    ...(layout ? { layout } : {}),
  }
}

export default getAgentAndChatbotDetails
